// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MerchantApiTokensCard_wrapper__rupPj th:first-child, .MerchantApiTokensCard_wrapper__rupPj td:last-child {
  width: 1%;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/settings-page/MerchantApiTokensCard.module.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,mBAAmB;AACrB","sourcesContent":[".wrapper th:first-child, .wrapper td:last-child {\n  width: 1%;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `MerchantApiTokensCard_wrapper__rupPj`
};
export default ___CSS_LOADER_EXPORT___;
